import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

type styleProps = {
  interactive: boolean;
};

export default makeStyles(({ spacing, palette }) => ({
  root: {
    borderRadius: spacing(1),
    transition: "background .3s",
    padding: spacing(3),

    "&:hover": {
      background: ({ interactive }: styleProps) =>
        interactive ? grey[100] : "none",
    },

    "&:hover $action": {
      opacity: 1,
    },

    "&:hover $drag": {
      opacity: 1,
      position: "relative",
    },
  },
  /**
   * A section inherited from the library: grey body plus the badge below, so the
   * distinction between a linked and a local card is visible at a glance and not
   * only once the form is opened.
   */
  linked: {
    position: "relative",
    background: grey[100],
    border: `1px solid ${palette.divider}`,
    marginTop: spacing(1.5),
  },
  /** Straddles the card's top edge, per the design. */
  linkedBadge: {
    position: "absolute",
    top: -12,
    left: 0,
    display: "inline-flex",
    alignItems: "center",
    gap: spacing(0.5),
    background: palette.background.paper,
    border: `1px solid ${palette.divider}`,
    borderRadius: spacing(2),
    padding: spacing(0.25, 1),
    fontSize: 12,
    color: grey[700],

    "@media print": {
      display: "none",
    },
  },
  /** Trails the label, and monochrome with it: the chip marks provenance, it is
   * not an action to draw the eye. */
  linkedBadgeIcon: {
    fontSize: 14,
    color: grey[700],
  },
  /** Tooltip anchor for a button that may be disabled — see the note there. */
  actionWrap: {
    display: "inline-flex",
  },
  /** Pencil-with-lock: the form still opens, but its master fields are locked. */
  lockedEdit: {
    position: "relative",
    display: "inline-flex",
  },
  lockedEditBadge: {
    position: "absolute",
    right: -2,
    bottom: -2,
    fontSize: 12,
    color: grey[700],
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: spacing(2),
  },
  actions: {
    display: "flex",
    alignItems: "center",
    height: 32,
  },
  action: {
    opacity: 0,
    transition: "opacity .3s",
  },
  pin: {
    opacity: 1,
  },
  popup: {
    opacity: 1,
  },
  title: {
    fontSize: 21,
  },
  text: {
    lineHeight: 2,

    "& *:last-child": {
      marginBottom: 0,
    },
  },
  drag: {
    opacity: 0,
    position: "absolute",
    marginRight: spacing(4),
    cursor: "move",
    alignItems: "center",
    justifyContent: "center",
    transition: "display .3s",

    "&:active svg": {
      color: grey[800],
    },

    "& svg": {
      color: grey[500],
      transition: "color .3s",
    },
  },
  popupAction: {
    textTransform: "none",
    fontSize: "14px",
    color: grey[700],
    fontWeight: 400,
    borderRadius: spacing(3),
    padding: spacing(0.5, 1.5),
    backgroundColor: grey[100],
    "&:hover": {
      backgroundColor: "#ffffff",
    },
    display: "flex",
    gap: spacing(1),
    alignItems: "center",
  },
  shiftedPopupIcon: {
    paddingLeft: spacing(1),
  },
  popupTooltip: {
    fontSize: "12px",
    whiteSpace: "pre-line",
    fontWeight: 400,
  },
  noPrint: {
    "@media print": {
      display: "none",
    },
  },
}));
